import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@mui/material';
import { apply_setter_to_array, BoilerAdapter, HeatingCircuit, IOExtension, Pump, RelayControl, ThreewayTap, } from 'z3k-config';
import { boiler_id_2_adapter_slot, boiler_id_2_relay_id, boiler_water_sensor_id, dhw_boiler_pump_id, dhw_temp_sensor_id, } from '../constants';
import { getObjectLinks, getPumpId, getSensorId, getTapId } from '../utils/getters';
import { deleteIOExtension, getAllUsedIds } from '../utils/deleteIOExtension';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { maxStringLength, notEmptyTrimmedWithMsg, } from 'webui/Z3KConfigParser/validation/basic';
import { all, validate_array, validate_by_specification, } from 'webui/Z3KConfigParser/validation/collections';
import { DHWControlType, guess_dhw_control_type } from '../utils/dhw-control-type';
import { BoilerControlType, HeatingControlType, } from './type';
import { BoilerRow } from './configuration/boiler-row';
import { HeatingRow } from './configuration/heating-row';
import { Delete } from '@mui/icons-material';
import { DHWRow } from './configuration/dhw-row';
import { SettingContainer } from 'console/device-settings/z3k/components/material-utils/settings-card/container';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { findBoilerAdapterBySlot } from 'z3k-parser/lib/boiler-adapter';
import { getHeatingCircuitByType } from 'z3k-parser/lib';
export function guess_boiler_control_type(config, circuit) {
    if (circuit.control_devices.length == 0) {
        return BoilerControlType.OFF;
    }
    const control_id = circuit.control_devices[0];
    if (RelayControl.get.byId(config, control_id) != null)
        return BoilerControlType.RELAY;
    if (BoilerAdapter.get.byId(config, control_id) != null) {
        const slot = boiler_id_2_adapter_slot(circuit.id);
        if (slot != null) {
            if (findBoilerAdapterBySlot(config, slot) != null)
                return BoilerControlType.DIGITAL;
        }
        return BoilerControlType.UNKNOWN;
    }
    return BoilerControlType.UNKNOWN;
}
export function guess_heating_control_type(config, circuit) {
    if (circuit.control_devices.length == 0)
        return HeatingControlType.OFF;
    if (circuit.control_devices.some((control_device_id) => ThreewayTap.get.byId(config, control_device_id) != null))
        return HeatingControlType.MIX;
    if (Pump.get.byId(config, circuit.control_devices[0]) != null)
        return HeatingControlType.DIRECT;
    return HeatingControlType.OFF;
}
const ConfigurationPage = ({ tab_key, state, validation, onChangeState, }) => {
    const boilers_validation = unpack_validation(validation, 'boilers');
    const heating_validation = unpack_validation(validation, 'circuits');
    const dhw_validation = unpack_validation(validation, 'dhw');
    return (_jsxs(SettingContainer, { children: [_jsx(SettingCard, { title: "\u0422\u0435\u043F\u043B\u043E\u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u044B", children: state.boilers.map((boiler, i) => (_jsx(BoilerRow, { number: i + 1, settings: boiler, validation: unpack_validation(boilers_validation, i), onChange: (setter) => onChangeState(tab_key, {
                        boilers: apply_setter_to_array(state.boilers, boiler.id, setter),
                    }) }, boiler.id))) }), _jsx(SettingCard, { title: "\u041A\u043E\u043D\u0442\u0443\u0440\u044B \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F", children: state.circuits.map((circuit, i) => {
                    if (!circuit.isIOExtensionCircuit)
                        return (_jsx(HeatingRow, { number: i + 1, settings: circuit, validation: unpack_validation(heating_validation, i), onChange: (setter) => onChangeState(tab_key, {
                                circuits: apply_setter_to_array(state.circuits, circuit.id, setter),
                            }) }, circuit.id));
                    return null;
                }) }), state.io_extensions
                .filter(IOExtension.shownToUser)
                .filter((io) => !state.blackList.includes(io.id))
                .map((io, index) => {
                const relatedList = io.related_list;
                const allUsedIds = state.object_arrays
                    .filter((obj) => relatedList?.includes(obj.id))
                    .map((obj) => obj.objects_links);
                return (_jsxs(SettingCard, { title: `${io.name}: Контуры отопления`, header_props: {
                        action: (_jsx(IconButton, { onClick: () => {
                                const newBlackList = state.blackList.slice();
                                const allUsedIds = getAllUsedIds(state.io_extensions, state.object_arrays, io.id);
                                allUsedIds.forEach((circ) => circ.forEach((id) => newBlackList.push(id)));
                                onChangeState(tab_key, {
                                    io_extensions: state.io_extensions?.filter((io_ext) => io_ext.id !== io.id),
                                    blackList: newBlackList,
                                });
                            }, children: _jsx(Delete, {}) })),
                    }, children: [_jsxs("div", { children: ["\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440: ", io.serial] }), state.circuits
                            .filter((circuit) => allUsedIds.some((list) => list.includes(circuit.id)))
                            .map((circuit, i) => {
                            return (_jsx(HeatingRow, { number: i + 1, settings: circuit, validation: unpack_validation(heating_validation, i), onChange: (setter) => onChangeState(tab_key, {
                                    circuits: apply_setter_to_array(state.circuits, circuit.id, setter),
                                }) }, circuit.id));
                        })] }, index));
            }), _jsx(SettingCard, { title: "\u041A\u043E\u043D\u0442\u0443\u0440 \u0413\u0412\u0421", children: state.dhw.map((dhw, i) => (_jsx(DHWRow, { settings: dhw, validation: unpack_validation(dhw_validation, i), onChange: (setter) => onChangeState(tab_key, {
                        dhw: apply_setter_to_array(state.dhw, dhw.id, setter),
                    }) }, dhw.id))) })] }));
};
const name_validator = all(notEmptyTrimmedWithMsg('Укажите название контура'), maxStringLength(10, 'Не более 10 символов'));
export const configuration_tab = {
    key: 'configuration',
    title: 'Конфигурация',
    element: ConfigurationPage,
    isShown: (state, volatile_data) => {
        return volatile_data.service_mode;
    },
    data2state: ({ device }) => {
        return {
            boilers: getHeatingCircuitByType(device.z3k_config, HeatingCircuit.Type.BOILER).map((circuit) => {
                const control_type = guess_boiler_control_type(device.z3k_config, circuit);
                const slot = boiler_id_2_adapter_slot(circuit.id);
                const boiler_adapter = slot != null
                    ? findBoilerAdapterBySlot(device.z3k_config, slot)
                    : null;
                return {
                    id: circuit.id,
                    name: circuit.name,
                    control_type,
                    has_adapter_on_slot: slot != null && boiler_adapter != null,
                    show_unknown_option: control_type == BoilerControlType.UNKNOWN,
                };
            }),
            circuits: getHeatingCircuitByType(device.z3k_config, HeatingCircuit.Type.HEATING).map((circuit) => ({
                id: circuit.id,
                name: circuit.name,
                isIOExtensionCircuit: getObjectLinks(circuit.id, device.z3k_config?.object_arrays)
                    .length > 0,
                control_type: guess_heating_control_type(device.z3k_config, circuit),
            })),
            dhw: getHeatingCircuitByType(device.z3k_config, HeatingCircuit.Type.DHW).map((circuit) => {
                const boiler_adapter = findBoilerAdapterBySlot(device.z3k_config, 1);
                return {
                    id: circuit.id,
                    name: circuit.name,
                    control_type: guess_dhw_control_type(device.z3k_config, circuit),
                    has_adapter_on_slot_1: boiler_adapter != null,
                    boiler_second_channel: boiler_adapter != null
                        ? BoilerAdapter.isSecondChannel(boiler_adapter)
                        : false,
                };
            }),
            object_arrays: device.z3k_config?.object_arrays ?? [],
            io_extensions: device.z3k_config?.io_extensions ?? [],
            blackList: [],
        };
    },
    validate: validate_by_specification({
        boilers: validate_array(validate_by_specification({
            name: name_validator,
        })),
        circuits: validate_array(validate_by_specification({
            name: name_validator,
        })),
        dhw: validate_array(validate_by_specification({
            name: name_validator,
        })),
    }),
    state2data: (state) => (setter) => {
        let z3k_config = setter.z3k_config;
        state.boilers.forEach((boiler_settings) => {
            z3k_config = HeatingCircuit.get.modifyById(z3k_config, boiler_settings.id, (circuit) => {
                switch (boiler_settings.control_type) {
                    case BoilerControlType.OFF:
                        return {
                            ...HeatingCircuit.setEnabled(circuit, false),
                            name: boiler_settings.name,
                            control_devices: [],
                            water_temp_sensor: null,
                        };
                    case BoilerControlType.RELAY:
                        return {
                            ...HeatingCircuit.setEnabled(circuit, true),
                            name: boiler_settings.name,
                            control_devices: [boiler_id_2_relay_id(circuit.id)],
                            water_temp_sensor: boiler_water_sensor_id,
                        };
                    case BoilerControlType.DIGITAL: {
                        const adapter = findBoilerAdapterBySlot(z3k_config, boiler_id_2_adapter_slot(circuit.id));
                        return {
                            ...HeatingCircuit.setEnabled(circuit, true),
                            name: boiler_settings.name,
                            control_devices: [adapter.id],
                            water_temp_sensor: adapter.id,
                        };
                    }
                    case BoilerControlType.UNKNOWN:
                        return circuit;
                }
            });
        });
        state.circuits.forEach((circuit_settings) => {
            z3k_config = HeatingCircuit.get.modifyById(z3k_config, circuit_settings.id, (circuit) => {
                switch (circuit_settings.control_type) {
                    case HeatingControlType.OFF:
                        return {
                            ...HeatingCircuit.setEnabled(circuit, false),
                            name: circuit_settings.name,
                            control_devices: [],
                            water_temp_sensor: null,
                        };
                    case HeatingControlType.DIRECT:
                        return {
                            ...HeatingCircuit.setEnabled(circuit, true),
                            name: circuit_settings.name,
                            control_devices: [
                                getPumpId(z3k_config.object_arrays, z3k_config.pumps, circuit.id),
                            ],
                            water_temp_sensor: getSensorId(z3k_config.object_arrays, z3k_config.analog_temperature_sensors?.map((sens) => sens.id), circuit.id) ?? null,
                        };
                    case HeatingControlType.MIX:
                        return {
                            ...HeatingCircuit.setEnabled(circuit, true),
                            name: circuit_settings.name,
                            control_devices: [
                                getPumpId(z3k_config.object_arrays, z3k_config.pumps, circuit.id),
                                getTapId(z3k_config.object_arrays, z3k_config.threeway_taps, circuit.id),
                            ],
                            water_temp_sensor: getSensorId(z3k_config.object_arrays, z3k_config.analog_temperature_sensors?.map((sens) => sens.id), circuit.id) ?? null,
                        };
                }
            });
        });
        // Set BY_HEAT_REQUEST flag for all pumps of disabled circuits
        state.circuits
            .filter((circuit_settings) => circuit_settings.control_type == HeatingControlType.OFF)
            .forEach((circuit_settings) => {
            const pumpId = getPumpId(z3k_config.object_arrays, z3k_config.pumps, circuit_settings.id);
            if (pumpId != null)
                z3k_config = Pump.get.modifyById(z3k_config, pumpId, (pump) => Pump.setMode(pump, Pump.Mode.BY_HEAT_REQUEST));
        });
        state.dhw.forEach((dhw_settings) => {
            //Насос загрузки всегда по запросу
            z3k_config = Pump.get.modifyById(z3k_config, dhw_boiler_pump_id, (pump) => Pump.setMode(pump, Pump.Mode.BY_HEAT_REQUEST));
            //Ищем насос ЦН
            const pumpId = getPumpId(z3k_config.object_arrays, z3k_config.pumps, dhw_settings.id);
            if (dhw_settings.control_type == DHWControlType.OFF) {
                if (pumpId)
                    z3k_config = Pump.get.modifyById(z3k_config, pumpId, (pump) => Pump.setMode(pump, Pump.Mode.BY_HEAT_REQUEST));
            }
            //If turn on
            else {
                if (pumpId)
                    z3k_config = Pump.get.modifyById(z3k_config, pumpId, (pump) => Pump.setMode(pump, Pump.Mode.ALWAYS_WORK));
            }
        });
        state.dhw.forEach((dhw_settings) => {
            const adapter = findBoilerAdapterBySlot(z3k_config, 1);
            if (adapter != null) {
                //Если не двухконтурный или не котел + бойлер,
                // то надо выключить second_channel
                z3k_config = BoilerAdapter.get.modifyById(z3k_config, adapter.id, (b_adapter) => BoilerAdapter.setSecondChannel(b_adapter, dhw_settings.control_type === DHWControlType.OFF ||
                    dhw_settings.control_type === DHWControlType.BOILER
                    ? false
                    : dhw_settings.boiler_second_channel));
            }
            z3k_config = HeatingCircuit.get.modifyById(z3k_config, dhw_settings.id, (circuit) => {
                switch (dhw_settings.control_type) {
                    case DHWControlType.OFF:
                        return {
                            ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), false),
                            name: dhw_settings.name,
                            water_temp_sensor: null,
                            dhw_temp_sensor: null,
                            control_devices: [],
                        };
                    case DHWControlType.BOILER:
                        return {
                            ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), true),
                            name: dhw_settings.name,
                            water_temp_sensor: null,
                            dhw_temp_sensor: dhw_temp_sensor_id,
                            control_devices: [dhw_boiler_pump_id],
                        };
                    case DHWControlType.FLOW_DHW: {
                        const adapter = findBoilerAdapterBySlot(z3k_config, 1);
                        return {
                            ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, true), true),
                            name: dhw_settings.name,
                            water_temp_sensor: null,
                            dhw_temp_sensor: adapter.id,
                            control_devices: [adapter.id],
                        };
                    }
                    case DHWControlType.BOILER_PLUS_DHW_BOILER: {
                        const adapter = findBoilerAdapterBySlot(z3k_config, 1);
                        return {
                            ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), true),
                            name: dhw_settings.name,
                            water_temp_sensor: null,
                            dhw_temp_sensor: adapter.id,
                            control_devices: [adapter.id],
                        };
                    }
                }
            });
        });
        z3k_config = BoilerAdapter.get.modify(z3k_config, () => true, (boiler_adapter) => BoilerAdapter.setEnabled(boiler_adapter, HeatingCircuit.get.where(z3k_config, (hc) => hc.control_devices.includes(boiler_adapter.id)).length > 0));
        state.blackList.forEach((id) => {
            const newConfig = deleteIOExtension(z3k_config, id)?.config;
            if (newConfig != null) {
                z3k_config = newConfig;
            }
        });
        return { ...setter, z3k_config };
    },
};
